import React from "react";
import { observer } from "mobx-react";
import { GrossReceiptsStatusUpdateStore } from "../../store";
import { GrossReceiptsStatusUpdateForm } from "./GrossReceiptsStatusUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type GrossReceiptsStatusUpdateProps = {
  grossReceiptsStatusUpdateStore: GrossReceiptsStatusUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const GrossReceiptsStatusUpdate: React.FC<GrossReceiptsStatusUpdateProps> =
  observer(
    ({
      grossReceiptsStatusUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={grossReceiptsStatusUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={grossReceiptsStatusUpdateStore.savedButOutdated}
            onReload={() =>
              grossReceiptsStatusUpdateStore.reloadGrossReceiptsStatus()
            }
            reloadDisabled={grossReceiptsStatusUpdateStore.isProcessing}
          />
          <GrossReceiptsStatusUpdateForm
            grossReceiptsStatusUpdateStore={grossReceiptsStatusUpdateStore}
            name_esError={
              grossReceiptsStatusUpdateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setName_esValue(value);
            }}
            name_es={grossReceiptsStatusUpdateStore.entityValues.name_es}
            name_enError={
              grossReceiptsStatusUpdateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setName_enValue(value);
            }}
            name_en={grossReceiptsStatusUpdateStore.entityValues.name_en}
            name_ptError={
              grossReceiptsStatusUpdateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setName_ptValue(value);
            }}
            name_pt={grossReceiptsStatusUpdateStore.entityValues.name_pt}
            description_esError={
              grossReceiptsStatusUpdateStore.errors.description_es?.message
            }
            onDescription_esChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setDescription_esValue(value);
            }}
            description_es={
              grossReceiptsStatusUpdateStore.entityValues.description_es
            }
            description_enError={
              grossReceiptsStatusUpdateStore.errors.description_en?.message
            }
            onDescription_enChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setDescription_enValue(value);
            }}
            description_en={
              grossReceiptsStatusUpdateStore.entityValues.description_en
            }
            description_ptError={
              grossReceiptsStatusUpdateStore.errors.description_pt?.message
            }
            onDescription_ptChange={(value: string) => {
              grossReceiptsStatusUpdateStore.setDescription_ptValue(value);
            }}
            description_pt={
              grossReceiptsStatusUpdateStore.entityValues.description_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={grossReceiptsStatusUpdateStore.saveDisabled}
            onSave={() =>
              grossReceiptsStatusUpdateStore.saveGrossReceiptsStatus()
            }
            onCancel={() =>
              grossReceiptsStatusUpdateStore.cancelGrossReceiptsStatus()
            }
          />
          <ErrorDialog
            open={grossReceiptsStatusUpdateStore.errorDialogOpened}
            title={grossReceiptsStatusUpdateStore.errorTitle}
            description={grossReceiptsStatusUpdateStore.errorDescription}
            onClose={() => grossReceiptsStatusUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={grossReceiptsStatusUpdateStore.confirmDialogOpened}
            title={grossReceiptsStatusUpdateStore.confirmDialogTitle}
            description={
              grossReceiptsStatusUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              grossReceiptsStatusUpdateStore.executeConfirmedAction()
            }
            onCancel={() => grossReceiptsStatusUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
